<template>
    <div>
      <organization-chart :datasource="ds" pan="true" zoom="true"></organization-chart>
    </div>
  </template>
   
  <script>
    import Vue from 'vue'
    import OrganizationChart from 'vue-organization-chart'
    import 'vue-organization-chart/dist/orgchart.css'
   
    export default {
      components: {
        OrganizationChart
      },
      data () {
        return {
          ds: {
            'id': '1',
            'name': 'AVO',
            'title': 'Diretor do Grupo',
            'children': [
              { 'id': '2', 'name': 'A6i', 'title': 'Alexandre Kenji Takamura' },
              { 'id': '3', 'name': 'Teste', 'title': 'Maria José',
                'children': [
                  { 'id': '4', 'name': 'Tie Hua', 'title': 'senior engineer' },
                  { 'id': '5', 'name': 'Hei Hei', 'title': 'senior engineer',
                    'children': [
                      { 'id': '6', 'name': 'Pang Pang', 'title': 'engineer' },
                      { 'id': '7', 'name': 'Xiang Xiang', 'title': 'UE engineer' }
                    ]
                   }
                 ]
               },
              { 'id': '8', 'name': 'Hong Miao', 'title': 'department manager' },
              { 'id': '9', 'name': 'Chun Miao', 'title': 'department manager' }
            ]
          }
        }
      }
    }
  </script> 

<style scoped>
.orgchart { background: #fff; }
.orgchart td.left, .orgchart td.right, .orgchart td.top { border-color: #aaa; }
.orgchart td>.down { background-color: #aaa; }
.orgchart .middle-level .title { background-color: #006699; }
.orgchart .middle-level .content { border-color: #006699; }
.orgchart .product-dept .title { background-color: #009933; }
.orgchart .product-dept .content { border-color: #009933; }
.orgchart .rd-dept .title { background-color: #993366; }
.orgchart .rd-dept .content { border-color: #993366; }
.orgchart .pipeline1 .title { background-color: #996633; }
.orgchart .pipeline1 .content { border-color: #996633; }
.orgchart .frontend1 .title { background-color: #cc0066; }
.orgchart .frontend1 .content { border-color: #cc0066; }
</style>